import { OccupationalLevelTypes } from "../BEE123Enums";

export interface IOptions {
  label: string;
  value: string;
}

export const OccupationalLevelDisplayList = (): Array<IOptions> => {

  var OccupationalLevelList =
    [
      {
        label: "Top Management",
        value: OccupationalLevelTypes.Top_Management.toString(),
      },
      {
        label: "Senior Management",
        value: OccupationalLevelTypes.Senior_Management.toString(),
      },
      {
        label: "Middle Management",
        value: OccupationalLevelTypes.Middle_Management.toString(),
      },
      {
        label: "Junior Management",
        value: OccupationalLevelTypes.Junior_Management.toString(),
      },
      {
        label: "Semi skilled",
        value: OccupationalLevelTypes.Semi_Skilled.toString(),
      },
      {
        label: "Unskilled",
        value: OccupationalLevelTypes.Unskilled.toString(),
      }
    ];

  
  return OccupationalLevelList;
}

export const OccupationalLevelList = (): Array<IOptions> => {

  var OccupationalLevelList =
    [
      {
        label: "Executive Director",
        value: OccupationalLevelTypes.Executive_Director.toString(),
      },
      {
        label: "Other Executive Management",
        value: OccupationalLevelTypes.Other_Executive_Management.toString(),
      },
      {
        label: "Senior Management",
        value: OccupationalLevelTypes.Senior_Management.toString(),
      },
      {
        label: "Middle Management",
        value: OccupationalLevelTypes.Middle_Management.toString(),
      },
      {
        label: "Junior Management",
        value: OccupationalLevelTypes.Junior_Management.toString(),
      },
      {
        label: "Semi skilled",
        value: OccupationalLevelTypes.Semi_Skilled.toString(),
      },
      {
        label: "Unskilled",
        value: OccupationalLevelTypes.Unskilled.toString(),
      }
    ];

  
  return OccupationalLevelList;
}